import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconGridSolid = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M4 4h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zM4 10h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4zM4 16h4v4H4zm6 0h4v4h-4zm6 0h4v4h-4z" }, void 0) }, void 0));
const Memo = memo(SvgIconGridSolid);
export default Memo;
//# sourceMappingURL=IconGridSolid.js.map